import PropTypes from 'prop-types';
import { memo } from 'react';
import EntryListItemContainer from '../entryListItem/EntryListItemContainer';
import style from './entryList.module.less';
import { jsx as _jsx } from "react/jsx-runtime";
function EntryList({
  entryIds
}) {
  if (entryIds.length <= 0) {
    return null;
  }
  return /*#__PURE__*/_jsx("div", {
    className: style.container,
    children: /*#__PURE__*/_jsx("table", {
      className: style.table,
      children: /*#__PURE__*/_jsx("tbody", {
        children: entryIds.map(id => {
          return /*#__PURE__*/_jsx(EntryListItemContainer, {
            id: id
          }, id);
        })
      })
    })
  });
}
EntryList.propTypes = {
  entryIds: PropTypes.arrayOf(PropTypes.string)
};
export { EntryList };
export default /*#__PURE__*/memo(EntryList);